import { gql } from '@apollo/client';

export const GET_INSIGHT = gql`
  query getInsight($id: ID!) {
    insight: getInsight(id: $id) {
      id
      name
      image
      layout
      width
      height
      users {
        id
        firstName
        lastName
      }
      tags {
        id
        name
      }
      url
      description
      createdBy {
        id
        firstName
        lastName
      }
      funder {
        id
        name
      }
      serviceProvider {
        id
        name
      }
      institution {
        id
        name
      }
      organisations {
        id
        organisation {
          id
          isFunder
          isServiceProvider
          isInstitution
          isAdmin
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
            type {
              id
              name
            }
          }
        }
        users {
          id
        }
        status
        dateArchived
        createdAt
      }
      currentOrganisationUsers {
        id
        firstName
        lastName
      }
    }
  }
`;
